module.exports = "/dashboard/manage/positions/positionsGroupComponent-93848e.html";